import { Color } from '@technology/web3d';
import { Component, JSX } from 'solid-js';

export interface MeasurementItemProps {
  color: Color;
  icon: JSX.Element;
  label: JSX.Element;
  actionsMenu: JSX.Element;
  isSelected: boolean;
  dataTestid: string;
  onClick(): void;
}

export const MeasurementItem: Component<MeasurementItemProps> = (props) => {
  return (
    <div
      data-testid={props.dataTestid}
      class={`flex items-center rounded-lg border mt-2 cursor-pointer text-sm ${
        props.isSelected
          ? 'border-gray-600 shadow-lg'
          : 'border-gray-1 shadow-md'
      }`}
      onClick={() => {
        props.onClick();
      }}
    >
      <div
        class="min-w-1 h-10 rounded-full ml-2"
        style={{
          ['background-color']: props.color.getStyle(),
        }}
      />
      <div class="flex items-center justify-center min-w-14">{props.icon}</div>
      <div class="flex flex-1 flex-col justify-center min-h-10 px-3 my-2 border-x border-gray-1">
        {props.label}
      </div>
      <div
        class="px-2"
        onClick={(event: MouseEvent) => {
          event.stopPropagation();
        }}
      >
        {props.actionsMenu}
      </div>
    </div>
  );
};
